import type { Row } from '@tanstack/react-table';
import * as React from 'react';

import styles from '../styles.module.scss';

interface Props<T> {
	currentlyPreviewedRow: Nullable<Row<T>>;
	renderSidePanelContext: (selectedRow: Row<T>) => React.JSX.Element;
	renderSidePanelHeader: (selectedRow: Row<T>) => React.JSX.Element;
	renderSidePanelFooter?: (selectedRow: Row<T>) => React.JSX.Element;
}

function SidePanel<T>({ currentlyPreviewedRow, renderSidePanelContext, renderSidePanelHeader, renderSidePanelFooter }: React.PropsWithChildren<Props<T>>) {

	const defaultHeader = React.useMemo(() => {
		return (
			<span className={styles['container__side-panel__header__default']}>
				Preview Content
			</span>
		);
	}, []);

	const defaultContext = React.useMemo(() => (
		<div className={styles['container__side-panel__body__hint']}>
			Click a row to display detailed information.
		</div>
	), []);

	const defaultFooter = React.useMemo(() => {
		return (
			<span className={styles['container__side-panel__footer__default']} />
		);
	}, []);

	return (
		<div className={styles['container__side-panel']}>
			<div className={styles['container__side-panel__header']}>
				{currentlyPreviewedRow
					? renderSidePanelHeader(currentlyPreviewedRow)
					: defaultHeader
				}
			</div>
			<div className={renderSidePanelFooter ? styles['container__side-panel__body-with-footer'] : styles['container__side-panel__body']}>
				{currentlyPreviewedRow
					? renderSidePanelContext(currentlyPreviewedRow)
					: defaultContext
				}
			</div>
			{renderSidePanelFooter && <div className={styles['container__side-panel__footer']}>
				{currentlyPreviewedRow
					? renderSidePanelFooter(currentlyPreviewedRow)
					: defaultFooter
				}
			</div>}
		</div>
	);
}

export default React.memo(SidePanel) as typeof SidePanel;
